/**
 * SpecialistID — Product PDP modular bundle: QUANTITY
 * Part of the custom-product-* set (split out of the legacy custom-product.js).
 *
 * Owns quantity-input validation and pack-increment rounding (doneTyping).
 * Manages the allowExactQty one-shot flag via SPID.state so event listeners
 * in custom-product.js can set it without coupling to this module's internals.
 *
 * Public API: SPID.doneTyping()
 * Shared state: SPID.state.allowExactQty (boolean, one-shot, default false)
 *
 * Cross-module calls: SPID.quantityLogic, SPID.mapMsrpLogic,
 * SPID.updateTablePrice (volume-pricing, currently still in custom-product.js).
 *
 * LOAD ORDER: after custom-product-core.js + custom-product-data.js +
 * custom-product-inventory.js + custom-product-pricing.js, before custom-product.js.
 */
(function () {
  'use strict';

  const SPID = window.SPID;
  const quantityLogic = SPID.optional('quantityLogic');
  const mapMsrpLogic = SPID.mapMsrpLogic;

  // One-shot flag: when true, doneTyping skips pack-increment rounding so
  // the "set-qty-max" link can set a sub-pack exact quantity (e.g. remaining
  // deny-inventory). Reset to false after each doneTyping run.
  SPID.state.allowExactQty = false;

  function doneTyping() {
    const qtyInput = document.querySelector('.quantity__input');
    const min = parseInt(qtyInput?.getAttribute('min')) || 1;
    let qty = parseInt((qtyInput?.value || '').replace(/\D/g, ''));
    const increment = parseInt(qtyInput?.getAttribute('step')) || 1;

    if (isNaN(qty) || qty < min) {
      qty = min;
      if (qtyInput) qtyInput.value = min;
    }

    const stock = parseInt(qtyInput?.getAttribute('max'));
    if (!isNaN(stock)) {
      if (stock > 0 && qty > stock) {
        if (qtyInput) qtyInput.value = stock;
        qty = stock;
      }
    }

    quantityLogic();
    mapMsrpLogic();
    SPID.call('updateTablePrice');

    if (qty < min) {
      if (qtyInput) qtyInput.value = min;
    } else if (!SPID.state.allowExactQty && increment > 1) {
      // SPID-273: round onto the same grid the +/- buttons step on. The browser's
      // stepUp()/stepDown() count from the min attribute, so the valid quantities
      // are min, min + increment, min + 2*increment... Rounding to bare multiples
      // of the increment instead used to fight the buttons whenever min was not
      // itself a multiple (e.g. min 25 with 100-packs: + gave 125, this rounded it
      // back to 100, + gave 125 again - the quantity could never leave 25/100).
      const steps = Math.max(0, Math.round((qty - min) / increment));
      let roundedQty = min + steps * increment;

      // Never round up past available stock; drop to the previous valid step.
      if (!isNaN(stock) && stock > 0 && roundedQty > stock) {
        roundedQty = Math.max(min, roundedQty - increment);
      }

      if (qtyInput && roundedQty !== qty) qtyInput.value = roundedQty;
    }
    SPID.state.allowExactQty = false;
  }

  SPID.doneTyping = doneTyping;

  // Announce this module so main-product.liquid can leave it out safely.
  if (window.SPID && SPID.register) SPID.register('quantity');
})();
